import 'bootstrap-multiselect';
import { makeTablesResponsive } from './responsiveTables';

const formSelector = '[data-ajax-form]';
const formContainer = '[data-ajax-form-container]';
const formDropdown = '[data-ajax-form-dropdown]';
const paginationSelector = '[data-search-nav-url-with-form]';
const paginationGetter = 'search-nav-url-with-form';

bindForms($('body'));

function bindForms(scope: JQuery<HTMLElement>) {
    scope.find(formSelector).each((i, element) => {
        const form: JQuery<HTMLFormElement> = $(element) as JQuery<HTMLFormElement>;

        form.find(formDropdown).each((i, dropdownElement) => {
            const dropdown: JQuery<HTMLSelectElement> = $(dropdownElement) as JQuery<HTMLSelectElement>;

            dropdown.change(() => {
                form.submit();
            });
        });

        const replaceContainerCallback = (result) => {
            const html = $(result);

            form.parents(formContainer).replaceWith(html);

            bindForms(html);
            makeTablesResponsive(html);
        };

        scope.find(paginationSelector).each((i, paginationElement) => {
            const pagination = $(paginationElement);
            const paginationUrl = pagination.data(paginationGetter);

            pagination.click((e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                const formQueryString: string = form.serialize();
                const targetUrl = paginationUrl + '&' + formQueryString;

                $.get(targetUrl, replaceContainerCallback);
            });
        });

        form.submit((e) => {
            if (!form.valid()) {
                return;
            }

            e.preventDefault();

            const currentForm = e.target;
            const formMethod: string = currentForm.method.toLowerCase();
            if (formMethod === 'post') {
                $.post(currentForm.action, form.serialize(), replaceContainerCallback);
            } else {
                $.get(currentForm.action, form.serialize(), replaceContainerCallback);
            }
        });
    });
}
